// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/CommentCitationLinks.test.tsx
// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.comment-sources.text.spec.ts
import { ArrowSquareOut } from "@phosphor-icons/react";
import { Button, Dialog, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import {
  CITATION_CHIP_CLASS,
  CITATION_DIALOG_CONTENT_CLASS,
} from "./citationChipStyles";

import { Preview } from "../../../../components/Preview";
import {
  type TicketMessageCitation,
  citationLabel,
  isTextCitation,
} from "../../utils/commentSourceUtils";

/** A bare excerpt from the org's custom guidelines — the generic fallback
 *  variant, which is why the dispatcher tries it last. */
export function TextCitationLink({
  citation,
}: {
  citation: TicketMessageCitation;
}) {
  const { t } = useTranslation("ui");
  if (!isTextCitation(citation)) return null;
  const label = citationLabel(citation);

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <button
          type="button"
          data-testid="comment-panel-citation-text"
          className={CITATION_CHIP_CLASS}
        >
          <Text as="span" size="1" weight="medium">
            {label}
          </Text>
          <ArrowSquareOut size={12} aria-hidden="true" />
        </button>
      </Dialog.Trigger>
      <Dialog.Content
        data-testid="comment-citation-guideline-dialog"
        className={CITATION_DIALOG_CONTENT_CLASS}
      >
        <Dialog.Title>{t("commentCitationLinks.guidelineSource")}</Dialog.Title>
        <Dialog.Description className="hidden">
          {t("commentCitationLinks.guidelineExcerpt")}
        </Dialog.Description>
        <Text size="2" className="text-puntt-neutral-gray-11">
          <em>{t("commentCitationLinks.fromCustomGuidelines")}</em>
        </Text>
        {/* Guarded, as the rule dialog next door already guards its quote:
            `urlToPreviewType` answers "unknown" for no-url-and-no-text, and an
            empty string is falsy -- so an unguarded Preview renders "Sorry, we
            can't preview this file type." over a citation whose only problem
            is that it carries no excerpt. */}
        {citation.text ? (
          <Preview text={citation.text} />
        ) : (
          <Text size="2" className="text-puntt-neutral-gray-11">
            {t("commentCitationLinks.noExcerpt")}
          </Text>
        )}
        <Dialog.Close>
          <Button type="button" variant="soft" color="gray">
            {t("commentCitationLinks.close")}
          </Button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Root>
  );
}
